var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Fiverr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "112px",
    height: "112px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#808080",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.86,21.321v-1.539h-2.919l-1.283,-0.022c-1.097,0 -1.847,0.722 -2.141,1.561v-1.539h-3.269v9.979h3.269v-2.14v-3.312c0,-0.995 0.806,-1.801 1.801,-1.801h1.274v7.253h3.269v-2.14v-3.312c0,-0.995 0.806,-1.801 1.801,-1.801h1.623v-2.726l-1.283,-0.022c-1.097,-0.001 -1.846,0.722 -2.142,1.561zM18.597,19.991l-1.754,5.767l-1.754,-5.767h-3.269l3.551,9.979h0.191h2.562h0.191l3.551,-9.979zM5.239,19.991v-0.665c0,-0.583 0.472,-1.055 1.055,-1.055h2.064v-2.737h-2.835c-1.962,0 -3.553,1.591 -3.553,3.553v0.905h-1.911v2.645h1.911v7.334h3.27v-7.334h3.118v7.334h3.269v-7.334v-2.645h-3.269h-3.119zM26.398,19.857h-0.398c-2.678,0 -4.849,2.171 -4.849,4.849v0.548c0,2.678 2.171,4.849 4.849,4.849h0.885c1.834,0 3.403,-1.132 4.048,-2.735l-2.884,-0.842c0,0 -0.345,0.988 -1.548,0.988c-1.358,0 -2.077,-0.744 -2.172,-1.586h-0.001v-0.005c-0.007,-0.061 -0.01,-0.123 -0.01,-0.185h3.688h3.242v-1.032c0,-2.678 -2.171,-4.849 -4.85,-4.849zM24.322,23.814c0.039,-0.897 0.777,-1.613 1.684,-1.613h0.312c0.907,0 1.645,0.716 1.684,1.613zM47.932,26.136c-1.123,0 -2.033,0.91 -2.033,2.033c0,1.123 0.91,2.033 2.033,2.033c1.123,0 2.033,-0.91 2.033,-2.033c-0.001,-1.123 -0.91,-2.033 -2.033,-2.033z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Fiverr);
export default __webpack_public_path__ + "static/media/icons8-fiverr.66c61e81e61b4d80daa648e2ebc0c9ac.svg";
export { ForwardRef as ReactComponent };